import { useTranslation } from 'react-i18next';

export const useMessagePrettifier = (): {
  p: (valueType: string, listType: string, action: string, result: string) => string;
} => {
  const { t } = useTranslation();
  return {
    p: function(valueType: string, listType: string, action: string, result: string): string {
      return t(`settings.blocklistAllowlist.notifications.${action}.${result}`, {
        record: valueType
          .replace(/^[a-z]*A|^[a-z]/, match => match.toUpperCase())
          .split(/(IP)/)
          .join(' '),
        list: listType.replace(listType.charAt(0), match => match.toUpperCase()),
      });
    },
  };
};
